import SvgComponent from "components/contact/svgComponent";
import Button from "components/general/buttonv2";
import {
  StyledBody,
  StyledHalf,
  StyledHalfImage,
  StyledSvgWrapper,
} from "components/general/stylingHero";
import { downloadsDisabled } from "data/variables";
import { businessData } from "src/data/businessData";
import styled from "styled-components";

export const StyledContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 1280px;
  position: relative;
  padding: 4rem;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    padding: 0 0 2rem 0;
  }
`;
const StyledButtonRow = styled.div`
  display: flex;
  align-items: center;
  > * {
    margin-right: 1rem;
    @media screen and (max-width: 768px) {
      margin-bottom: 1rem;
    }
  }
  @media screen and (max-width: 992px) {
    flex-direction: column;
    align-items: flex-start;
  }
  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    svg {
      margin-top: 1rem;
    }
  }
`;

const StyledWrapper = styled.section`
  position: relative;
  display: flex;
  width: 100%;
  overflow: hidden;
  justify-content: center;
  margin-bottom: ${(props) => props.marginBottom || "0px"};
  padding: 0rem 2rem 0 2rem;
  background: var(--background-color);
  @media screen and (max-width: 768px) {
    height: auto;
    padding: 4rem 2rem 0 2rem;
  }
  h2 {
    font-size: 3rem;
    line-height: 4.2rem;
    font-weight: 700;
    width: 100%;
    text-align: left;
    margin-bottom: 2rem;
    @media screen and (max-width: 992px) {
      line-height: 2.8rem;
      font-size: 2rem;
    }
    @media screen and (max-width: 768px) {
      text-align: left;
    }
  }
`;

const Cta = () => {
  return (
    <>
      <StyledWrapper>
        <StyledContainer>
          <StyledHalf tabletFlex="2">
            <h2>Pricing</h2>
            <StyledBody>{businessData.bottomText}</StyledBody>
            <StyledButtonRow>
              <Button
                disabled={downloadsDisabled}
                to="mailto:noah@redact.dev"
                data-action-name="Cta: Download"
                buttonPrimary={true}
              >
                Contact us
              </Button>
            </StyledButtonRow>
          </StyledHalf>
          <StyledHalfImage>
            <StyledSvgWrapper>
              <SvgComponent />
            </StyledSvgWrapper>
          </StyledHalfImage>
        </StyledContainer>
      </StyledWrapper>
      <StyledWrapper style={{ background: "var(--raised-background-color)" }}>
        <StyledContainer style={{ flexDirection: "column", alignItems: "center" }}>
          <h2 style={{ textAlign: "center" }}>Connect. Manage. Delete.</h2>
          <p style={{ marginBottom: "4rem" }}>
            Step up your game in social media management for your business - it&apos;s time to take
            charge!
          </p>
          <Button
            disabled={downloadsDisabled}
            to="https://cal.com/noah-redact.dev"
            data-action-name="Cta: Download"
            buttonPrimary={true}
            alignSelf="center"
            style={{ marginBottom: "3rem" }}
          >
            Book a demo
          </Button>
        </StyledContainer>
      </StyledWrapper>
    </>
  );
};

export default Cta;
